import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

export const RedirectInvestorsToClients = () => <Navigate to='/clients' replace />

export const RedirectInvestorProfileToClient = () => {
  const { investorId } = useParams()
  return <Navigate to={`/client/${investorId}/profile`} replace />
}

export const RedirectInvestmentDetailInvestorSegment = () => {
  const { projectSlug, projectId, investorId, investmentId } = useParams()
  return (
    <Navigate
      to={`/opportunity/${projectSlug}/${projectId}/client/${investorId}/investment/detail/${investmentId}`}
      replace
    />
  )
}

export const RedirectWithdrawalDetailInvestorSegment = () => {
  const { projectSlug, projectId, investorId, withdrawalId } = useParams()
  return (
    <Navigate
      to={`/opportunity/${projectSlug}/${projectId}/client/${investorId}/withdrawal/detail/${withdrawalId}`}
      replace
    />
  )
}
